import { cn } from "@/lib/utils";
import { Calendar, MapPin, Users } from "lucide-react";
import { BadgePill } from "./BadgePill";
import { StatusLight } from "./StatusLight";

const statusToBadge = {
  live: 'success',
  upcoming: 'primary',
  draft: 'muted',
  ended: 'default',
  cancelled: 'error',
};

export const EventCard = ({ 
  name, 
  date, 
  time,
  location, 
  capacity,
  attendees,
  status = 'upcoming',
  onClick,
  className 
}) => {
  return (
    <div 
      className={cn(
        "bg-graphite rounded-xl border border-white/[0.06] p-5 transition-all duration-200",
        "hover:border-white/[0.12] hover:bg-graphite/80 cursor-pointer",
        className
      )}
      onClick={onClick}
      data-testid="event-card"
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <h3 className="text-lg font-medium text-cloud-white line-clamp-1">
          {name}
        </h3>
        <BadgePill variant={statusToBadge[status]}>
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </BadgePill>
      </div>
      
      <div className="space-y-2 text-sm text-soft-silver">
        <div className="flex items-center gap-2">
          <Calendar className="w-4 h-4 text-muted-text" />
          <span className="font-mono">{date}</span>
          {time && <span className="text-muted-text">• {time}</span>}
        </div>
        
        <div className="flex items-center gap-2">
          <MapPin className="w-4 h-4 text-muted-text" />
          <span className="line-clamp-1">{location}</span>
        </div>
        
        {capacity && (
          <div className="flex items-center gap-2">
            <Users className="w-4 h-4 text-muted-text" />
            <span className="font-mono">
              {attendees || 0} / {capacity}
            </span>
            {attendees >= capacity && (
              <BadgePill variant="warning" className="ml-2">Full</BadgePill>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCard;
